export { InvestmentBankingCaseStudiesPage as default } from "@nvb/ui";
